import React from 'react'
import { useSelector } from 'react-redux'
import { getVideo } from 'Utils/videoUrls'
import { useGetVideoByIdQuery } from 'Services/institution'

const IntroVideo = () => {
  const { introMedia, locId, instId } = useSelector(
    (state: any) => state.location
  )

  const { data: videoData } = useGetVideoByIdQuery(
    { instId, locId, videoId: introMedia },
    { skip: !instId || !locId || !introMedia }
  )

  const video = videoData?.resources?.video

  if (!introMedia || !video) {
    return null
  }

  return (
    <div>
      <h2>Intro Video</h2>
      {getVideo(video)}
      <br />
      <br />
    </div>
  )
}

export default IntroVideo
